function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m59.9 17c-23.7 0-42.9 19.2-42.9 42.9v3.5h24.3v22.3c0 4.5 2.2 8.8 5.8 11.5 4 3 8.5 4.5 12.9 4.5 2.9 0 5.7-.7 8.3-2 6.3-3.2 10.2-9.6 10.2-16.6v-19.7h24.3v-3.5c0-23.7-19.2-42.9-42.9-42.9zm11.6 66c0 4.4-2.4 8.3-6.4 10.3-4.3 2.2-9.3 1.5-13.9-1.9-1.8-1.3-2.9-3.5-2.9-5.8v-22.2h23.1v19.6zm-47.3-26.6c1.8-18.1 17.1-32.3 35.7-32.3s33.9 14.2 35.7 32.3z",
  fill: "#015168",
  fillRule: "evenodd"
});

var SvgSienestysJaMarjastus = function SvgSienestysJaMarjastus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 120 120",
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSienestysJaMarjastus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sienestys-ja-marjastus.1fa332ba.svg";
export { ForwardRef as ReactComponent };